import { ArrowRight, Play } from "lucide-react";
import { MockupCheckin, MockupDashboard } from "./Mockups";

export function Hero() {
  return (
    <section className="relative overflow-x-hidden">
      <div className="blur-blob -left-32 -top-20 h-96 w-96 bg-primary/30" />
      <div className="blur-blob -right-32 top-40 h-[28rem] w-[28rem] bg-secondary/30" />
      <div className="relative mx-auto max-w-7xl px-4 pt-20 pb-0 sm:px-6 lg:px-8 lg:pt-28">
        <div className="mx-auto max-w-3xl text-center">
          <span className="inline-flex items-center gap-2 rounded-full border border-border bg-card/60 px-3 py-1 text-xs font-medium text-muted-foreground backdrop-blur">
            <span className="h-1.5 w-1.5 rounded-full bg-primary" />
            Plataforma B2B de bienestar emocional en tiempo real
          </span>
          <h1 className="mt-6 text-4xl font-semibold tracking-tight text-foreground sm:text-5xl lg:text-6xl">
            Reduce la rotación del talento <br className="hidden sm:block" />
            y el <span className="text-gradient-brand">absentismo de tu empresa</span>
          </h1>
          <p className="mx-auto mt-6 max-w-2xl text-lg text-muted-foreground">
            Una solución para líderes que cuidan a sus equipos día a día
          </p>
          <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
            <a
              href="#cta"
              className="inline-flex items-center justify-center rounded-full gradient-brand px-6 py-3 text-sm font-medium text-white shadow-glow transition hover:opacity-95"
            >
              Solicitar demo <ArrowRight className="ml-1 h-4 w-4" />
            </a>
            <a
              href="#como-funciona"
              className="inline-flex items-center justify-center rounded-full border border-border bg-card/60 px-6 py-3 text-sm font-medium text-foreground backdrop-blur transition hover:bg-card"
            >
              <Play className="mr-1 h-4 w-4" /> Ver cómo funciona
            </a>
          </div>
          <p className="mt-5 text-sm text-muted-foreground">
            No es una encuesta. Es <span className="font-medium text-foreground">acompañamiento en tiempo real</span>.
          </p>
        </div>

        <div className="relative mx-auto mt-12 lg:-mt-4 max-w-6xl">
          <div className="absolute inset-x-0 -top-8 mx-auto h-72 w-3/4 rounded-full bg-gradient-to-r from-primary/20 via-transparent to-accent/20 blur-3xl" />
          <div className="relative flex items-center justify-center gap-3">
            {/* Phone — left, starts at button row level to give depth */}
            <div className="hidden animate-float lg:block shrink-0 -mt-8">
              <MockupCheckin />
            </div>
            {/* Dashboard — right, vertically centered with phone */}
            <div className="flex-1 min-w-0">
              <MockupDashboard />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
